import { ReactNode } from "react";

import AccountSignalHistory from "../Pages/AccountSignalHistory";
import AccountSynopsis from "../Pages/AccountSynopsis";
import AccountWorkspace from "../Pages/AccountWorkspace";
import AlwaysOnChannel from "../Pages/AlwaysOnChannel";
import ComingSoon from "../Pages/ComingSoon";
import CoveragePage from "../Pages/CoverageAnalysis";
import ExecutiveSponsoreHome from "../Pages/ExecutiveSponsoreHome";
import ExecutiveStaff from "../Pages/ExecutiveStaff";
import GuidancePlaybooks from "../Pages/GuidancePlaybooks";
import LeaderboardPage from "../Pages/Leaderboard";
import MyCheckIns from "../Pages/MyCheckIns";
import MyCheckInsPerformance from "../Pages/MyCheckIns/Performance";
import MyPortfolioAccounts from "../Pages/MyPortfolioAccounts";
import Relationship from "../Pages/Relationship";
import ReviewAssessments from "../Pages/ReviewAssessments";
import SponsorDrilldownPage from "../Pages/SponsorDrilldown";
import SponsorTipDetail from "../Pages/SponsorTipDetail";
import SponsorTipsLibrary from "../Pages/SponsorTipsLibrary";
import TeamViewsPage from "../Pages/TeamViews";
import TempViewsRendering from "../Pages/TempViewsRendering";
import XFactorBriefings from "../Pages/XFactorBriefings";

export interface ExecutiveSponsoreRoute {
  path: string;
  element: ReactNode;
  label?: string;
}

const executiveSponsoreRoutes: ExecutiveSponsoreRoute[] = [
  {
    path: "/",
    element: <ExecutiveSponsoreHome />,
    label: "Home",
  },
  {
    path: "/home",
    element: <ExecutiveSponsoreHome />,
    label: "Home",
  },
  {
    path: "/always-on-channel",
    element: <AlwaysOnChannel />,
    label: "Always On Intelligence",
  },
  {
    path: "/public-data-briefings",
    element: <XFactorBriefings />,
    label: "Business Health Briefing",
  },
  {
    path: "/views-rendering",
    element: <TempViewsRendering />,
    label: "Temp Views Rendering",
  },
  {
    path: "/guidance-library",
    element: <SponsorTipsLibrary />,
    label: "Guidance Library",
  },
  {
    path: "/guidance-library/:slug",
    element: <SponsorTipDetail />,
    label: "Guidance Detail",
  },
  {
    path: "/about/overview",
    element: <ComingSoon title="EB Overview" />,
    label: "EB Overview",
  },
  {
    path: "/about/xfactor",
    element: <ComingSoon title="XFACTOR Levels" />,
    label: "XFACTOR Levels",
  },
  {
    path: "/help",
    element: <ComingSoon title="Help & Support" />,
    label: "Help & Support",
  },
  {
    path: "/relationship",
    element: <Relationship />,
    label: "Relationships",
  },
  {
    path: "/pending-assessments",
    element: <ReviewAssessments />,
    label: "My Assessments",
  },
  {
    path: "/account-workspace/:id",
    element: <AccountWorkspace />,
    label: "Account Workspace",
  },
  {
    path: "/account-synopsis/:accountId",
    element: <AccountSynopsis />,
    label: "Account Synopsis",
  },
  {
    path: "/account-signal-history/:accountId",
    element: <AccountSignalHistory />,
    label: "Account Signal History",
  },
  {
    path: "/executive-staff",
    element: <ExecutiveStaff />,
    label: "Executive Staff",
  },
  {
    path: "/team-views",
    element: <TeamViewsPage />,
    label: "Team Views",
  },
  {
    path: "/coverage",
    element: <CoveragePage />,
    label: "Coverage",
  },
  {
    path: "/my-check-ins",
    element: <MyCheckIns />,
    label: "My Check-Ins",
  },
  {
    path: "/my-check-ins/performance",
    element: <MyCheckInsPerformance />,
    label: "My Performance",
  },
  {
    path: "/my-portfolio-accounts",
    element: <MyPortfolioAccounts />,
    label: "My Portfolio Accounts",
  },
  {
    path: "/goals-milestones",
    element: <ComingSoon title="Goals & Milestones" />,
    label: "Goals & Milestones",
  },
  {
    path: "/leaderboard",
    element: <LeaderboardPage />,
    label: "Leaderboard",
  },
  {
    path: "/sponsor-drilldown",
    element: <SponsorDrilldownPage />,
    label: "Sponsor Drilldown",
  },
  {
    path: "/dashboard",
    element: <ComingSoon title="Dashboard" />,
    label: "Dashboard",
  },
  {
    path: "/guidance/playbooks",
    element: <GuidancePlaybooks />,
    label: "Playbooks Hub",
  },
];

export default executiveSponsoreRoutes;
